import aiAssistantPic from 'src/assets/brand/AIAssistant.jpg'
import aoiPic1 from 'src/assets/devices/house.jpg'
import aoiPic2 from 'src/assets/devices/flat.jpg'
import aoiPic3 from 'src/assets/devices/car.jpeg'
import aoiPic4 from 'src/assets/devices/health.jpeg'
import aoiPic1000 from 'src/assets/devices/manager.jpeg'
import aoiPic1001 from 'src/assets/devices/innovator.jpeg'
import aoiPic1002 from 'src/assets/devices/hr.jpeg'
import aoiPic1003 from 'src/assets/devices/pm.jpeg'
import { BASE_URL } from '../apiConfig'
import i18n from './i18nConfig'

export const languageOptions = [
  { code: 'en', flag: '🇬🇧🇺🇸', name: 'English' },
  { code: 'fr', flag: '🇫🇷', name: 'Français' },
  { code: 'es', flag: '🇪🇸', name: 'Español' },
  { code: 'cz', flag: '🇨🇿', name: 'Čeština' },
  { code: 'de', flag: '🇩🇪', name: 'Deutsch' },
  { code: 'zh', flag: '🇨🇳', name: '中文' },
  { code: 'hi', flag: '🇮🇳', name: 'हिन्दी' },
  { code: 'it', flag: '🇮🇹', name: 'Italiano' },
]

export const API_ENDPOINTS = Object.freeze({
  account: 'account.php',
  accountPrimary: 'account_1.php',
  accountCreate: 'account_create.php',
  accountDelete: 'account_delete.php',
  accountNameUpdate: 'account_name_update.php',
  accountMembershipUpdate: 'accounts_membership_update.php',
  accountRemindersCreate: 'account_reminders_create.php',
  accountDamage: 'accountdamage.php',
  accountDamageAll: 'accountdamageall.php',
  accountFinances: 'accountfinances.php',
  accountId: 'accountID.php',
  accountReminders: 'accountreminders.php',
  accountRemindersAllActiveInMonth: 'accountremindersallactiveinmonth.php',
  accountRemindersDone: 'accountremindersdone.php',
  accountRemindersIgnored: 'accountremindersignored.php',
  accountRemindersProgress: 'accountremindersprogress.php',
  accountRemindersProgressAll: 'accountremindersprogressall.php',
  accountRemindersSwitchedOff: 'accountremindersswitchedoff.php',
  accountsReminderUpdate: 'accounts_reminder_update.php',
  accountsTransferContactTaskUpdate: 'accounts_transfercontacttask_update.php',
  accountsTransferContactUpdate: 'accounts_transfercontactupdate_update.php',
  accountsScoreUpdate: 'accounts_score_update.php',
  accountsScoreMonthUpdate: 'accounts_score_month_update.php',
  accountsScoreCarUpdate: 'accounts_score_car_update.php',
  accountsScoreFlatUpdate: 'accounts_score_flat_update.php',
  accountsScoreHealthUpdate: 'accounts_score_health_update.php',
  accountsScoreHouseUpdate: 'accounts_score_house_update.php',
  accountsScoreHrUpdate: 'accounts_score_hr_update.php',
  accountsScoreInnovatorUpdate: 'accounts_score_innovator_update.php',
  accountsScoreManagerUpdate: 'accounts_score_manager_update.php',
  accountsScoreProjectUpdate: 'accounts_score_project_update.php',
  accountsYearlyClosure: 'accounts_yearly_closure.php',
  accountsClosureYearUpdate: 'accounts_closure_year_update.php',
  accountsGenderUpdate: 'accounts_gender_update.php',
  accountsMailInsert: 'accounts_mail_insert.php',
  accountsHouseConfigUpdate: 'accounts_houseconfig_update.php',
  accountsHouseAgeUpdate: 'accounts_houseage_update.php',
  accountsFlatConfigUpdate: 'accounts_flatconfig_update.php',
  accountsFlatAgeUpdate: 'accounts_flatage_update.php',
  accountsCarConfigUpdate: 'accounts_carconfig_update.php',
  accountsCarAgeUpdate: 'accounts_carage_update.php',
  accountsHealthConfigUpdate: 'accounts_healthconfig_update.php',
  accountsHealthAgeUpdate: 'accounts_healthage_update.php',
  accountsManagerConfigUpdate: 'accounts_managerconfig_update.php',
  accountsManagerAgeUpdate: 'accounts_managerage_update.php',
  accountsInnovatorConfigUpdate: 'accounts_innovatorconfig_update.php',
  accountsInnovatorAgeUpdate: 'accounts_innovatorage_update.php',
  accountsHrConfigUpdate: 'accounts_hrconfig_update.php',
  accountsHrAgeUpdate: 'accounts_hrage_update.php',
  accountsProjectConfigUpdate: 'accounts_projectconfig_update.php',
  accountsProjectAgeUpdate: 'accounts_projectage_update.php',
  aiAdvices: 'aiadvices.php',
  aois: 'aois.php',
  appParameters: 'appparameters.php',
  cafeteria: 'cafeteria.php',
  eshop: 'eshop.php',
  eshopCatalogue: 'eshop_catalogue.php',
  eshopPayment: 'eshop_payment.php',
  eshopTransport: 'eshop_transport.php',
  eshopBought: 'eshop_bought.php',
  eshopItemAdd: 'eshop/eshop_item_add.php',
  eshopItemCountUpdate: 'eshop/eshop_item_count_update.php',
  eshopItemDelete: 'eshop/eshop_item_delete.php',
  eshopItemSend: 'eshop/eshop_item_send.php',
  eshopItemStatus: 'eshop/eshop_item_status.php',
  memberships: 'memberships.php',
  message: 'message.php',
  messageTemplate: 'message_template.php',
  messageUpdate: 'message_update.php',
  messages: 'messages.php',
  messagesSystem: 'messages_system.php',
  messagesTemplates: 'messages_templates.php',
  messagesTemplatesLimit: 'messages_templates_limit.php',
  messagesUnreaded: 'messages_unreaded.php',
  projects: 'projects.php',
  recommendations: 'recommendations.php',
  reminders: 'reminders.php',
  remindersGroup: 'remindersgrp1.php',
  remindersShared: 'reminders_shared.php',
  remindersStatusUpdate: 'reminders_status_update.php',
  remindersDueDateUpdate: 'reminders_duedate_update.php',
  remindersTop: 'reminderstop1.php',
  remindersTopAll: 'reminderstop1_of_all.php',
  remindersTopAllInMonth: 'reminderstop1allinmonth.php',
  remindersTop3: 'reminderstop3.php',
  startupAssign: 'startup_assign.php',
  startupIdeaSave: 'startup_idea_save.php',
  startupIdeaSaveProject: 'startup_idea_save_project.php',
  startupIdeaSaveProjectStatus: 'startup_idea_save_project_status.php',
  startupUnassign: 'startup_unassign.php',
  startups: 'startups.php',
  startupsList: 'startups_list.php',
  supplierAssign: 'supplier_assign.php',
  supplierAssignManual: 'supplier_assign_manual.php',
  supplierPref: 'supplier_pref.php',
  supplierPrefManual: 'supplier_pref_manual.php',
  supplierUnassign: 'supplier_unassign.php',
  supplierUnassignManual: 'supplier_unassign_man.php',
  suppliers: 'suppliers.php',
  trends: 'trends.php',
})
// Konfigurace oblastí zájmu (AOI)
export const AOI_FULL_CONFIG = [
  {
    key: 'house',
    grp_ID: 1,
    image: aoiPic1,
    riskLabelKey: 'aoi.house.risk',
    labelKey: 'aoi.house.label',
    color: 'primary',
    img: aoiPic1,
    configEndpoint: 'accounts_houseconfig_update.php',
    ageEndpoint: 'accounts_houseage_update.php',
    JSONfield: 'aoi1',
    targetWeight: 18,
    scoreEndpoint: 'accounts_score_house_update.php',
  },
  {
    key: 'flat',
    grp_ID: 2,
    image: aoiPic2,
    riskLabelKey: 'aoi.flat.risk',
    labelKey: 'aoi.flat.label',
    color: 'secondary',
    img: aoiPic2,
    configEndpoint: 'accounts_flatconfig_update.php',
    ageEndpoint: 'accounts_flatage_update.php',
    JSONfield: 'aoi2',
    targetWeight: 14,
    scoreEndpoint: 'accounts_score_flat_update.php',
  },
  {
    key: 'car',
    grp_ID: 3,
    image: aoiPic3,
    riskLabelKey: 'aoi.car.risk',
    labelKey: 'aoi.car.label',
    color: 'success',
    img: aoiPic3,
    configEndpoint: 'accounts_carconfig_update.php',
    ageEndpoint: 'accounts_carage_update.php',
    JSONfield: 'aoi3',
    targetWeight: 7,
    scoreEndpoint: 'accounts_score_car_update.php',
  },
  {
    key: 'health',
    grp_ID: 4,
    image: aoiPic4,
    riskLabelKey: 'aoi.health.risk',
    labelKey: 'aoi.health.label',
    color: 'danger',
    img: aoiPic4,
    configEndpoint: 'accounts_healthconfig_update.php',
    ageEndpoint: 'accounts_healthage_update.php',
    JSONfield: 'aoi4',
    targetWeight: 5,
    scoreEndpoint: 'accounts_score_health_update.php',
  },
  {
    key: 'manager',
    grp_ID: 1000,
    image: aoiPic1000,
    riskLabelKey: 'aoi.manager.risk',
    labelKey: 'aoi.manager.label',
    color: 'light',
    img: aoiPic1000,
    configEndpoint: 'accounts_managerconfig_update.php',
    ageEndpoint: 'accounts_managerage_update.php',
    JSONfield: 'aoi1000',
    targetWeight: 7,
    scoreEndpoint: 'accounts_score_manager_update.php',
  },
  {
    key: 'innovator',
    grp_ID: 1001,
    image: aoiPic1001,
    riskLabelKey: 'aoi.innovator.risk',
    labelKey: 'aoi.innovator.label',
    color: 'dark',
    img: aoiPic1001,
    configEndpoint: 'accounts_innovatorconfig_update.php',
    ageEndpoint: 'accounts_innovatorage_update.php',
    JSONfield: 'aoi1001',
    targetWeight: 1,
    scoreEndpoint: 'accounts_score_innovator_update.php',
  },
  {
    key: 'hr',
    grp_ID: 1002,
    image: aoiPic1002,
    riskLabelKey: 'aoi.hr.risk',
    labelKey: 'aoi.hr.label',
    color: 'info',
    img: aoiPic1002,
    configEndpoint: 'accounts_hrconfig_update.php',
    ageEndpoint: 'accounts_hrage_update.php',
    JSONfield: 'aoi1002',
    targetWeight: 7,
    scoreEndpoint: 'accounts_score_hr_update.php',
  },
  {
    key: 'project',
    grp_ID: 1003,
    image: aoiPic1003,
    riskLabelKey: 'aoi.project.risk',
    labelKey: 'aoi.project.label',
    color: 'light',
    img: aoiPic1003,
    configEndpoint: 'accounts_projectconfig_update.php',
    ageEndpoint: 'accounts_projectage_update.php',
    JSONfield: 'aoi1003',
    targetWeight: 7,
    scoreEndpoint: 'accounts_score_project_update.php',
  },
]

export const AI_ASSISTANT_IMAGE = aiAssistantPic

const serializeParams = (params) => {
  if (!params) return ''
  const searchParams = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return
    }
    if (Array.isArray(value)) {
      value.forEach((entry) => searchParams.append(key, String(entry)))
    } else {
      searchParams.append(key, String(value))
    }
  })
  return searchParams.toString()
}

export const buildApiUrl = (endpointKeyOrPath, params, options = {}) => {
  const path = API_ENDPOINTS[endpointKeyOrPath] ?? endpointKeyOrPath
  const url = new URL(path, options.baseUrl ?? BASE_URL)
  const query = serializeParams(params)
  if (query) {
    url.search = query
  }
  return url.toString()
}

export default function getGroupName(grpId) {
  const numericId = Number(grpId)
  if (!Number.isFinite(numericId)) {
    return ''
  }
  const match = AOI_FULL_CONFIG.find(({ grp_ID }) => grp_ID === numericId)
  if (!match) {
    return ''
  }
  if (match.labelKey) {
    return i18n.t(match.labelKey)
  }
  return match.label ?? match.key ?? ''
}

const SCORE_PREFIX_MAP = AOI_FULL_CONFIG.reduce((acc, { key }) => {
  if (key) {
    acc[key] = `score${key}`
  }
  return acc
}, {})

export const scoreKeys = [
  'score',
  ...Object.values(SCORE_PREFIX_MAP),
  'score1',
  'score2',
  'score3',
  'score4',
  'score5',
  'score6',
  'score7',
  'score8',
  'score9',
  'score10',
  'score11',
  'score12',
]

export const membershipModules = {
  PRO: {
    personal: [
      'pool', // pool care duties
      'garden', // garden care duties
      'pets', // pets care duties
      'children', // children care duties
      'parents', // parents care duties
      'partner', // partner care duties
      'cooking', // cooking planning and support
      'work', // work planning and support
      'payments', // payments evidence, planning and reminders
      'training', // skills training and development
      'fun', // fun activities planning and support
      'hobby', // hobby activities planning and support
      'transport', // transport planning and support
      'buying list', // buying list planning and sharing with partner - PRIO 1
      'homework', // homeworks allocation - PRIO 1
    ],
    business: [
      'resources', // resources management support
      'strategy', // business strategy planning and support - PRIO 1
      'projects', // projects management support
      'trainings', // trainings management support
      'compliance', // compliance management support
      'team', // team management support
    ],
  },
  ELITE: {
    personal: [
      'money', // money management support
    ],
    business: [
      'strategy', // business strategy planning and support
    ],
  },
  // ELITE: [],
  //  FAMILY: ['family', 'health'],
  //  INNO: ['innovation'],
  //  SELLER: ['custom-reminders'],
  //  SUPPLIER: ['supplier-tools']
  //}
}

export const PREMIUM_MEMBERSHIP_TYPES = new Set(['PRO', 'ELITE'])
export const TOP_MEMBERSHIP_TYPES = new Set(['ELITE'])

export const MAIL_ITEMS_CONFIG = [
  {
    key: 'support',
    label: 'Support',
    labelKey: 'headerDropdown.mailItems.support',
    logLabel: 'Support',
    requiresPremium: true,
    mail: {
      subjectKey: 'mailItems.support.subject',
      bodyKey: 'mailItems.support.body',
    },
  },
  {
    key: 'authorized-request',
    label: 'Authorized request',
    labelKey: 'headerDropdown.mailItems.authorizedRequest',
    logLabel: 'Authorized request',
    requiresPremium: true,
    mail: {
      subjectKey: 'mailItems.authorizedRequest.subject',
      bodyKey: 'mailItems.authorizedRequest.body',
    },
  },
  {
    key: 'add-reminder',
    label: 'Add new reminder',
    labelKey: 'headerDropdown.mailItems.addReminder',
    logLabel: 'Add new reminder',
    requiresPremium: true,
    mail: {
      subjectKey: 'mailItems.addReminder.subject',
      bodyKey: 'mailItems.addReminder.body',
    },
  },
  {
    key: 'bug-report',
    label: 'Report a BUG...',
    labelKey: 'headerDropdown.mailItems.bugReport',
    logLabel: 'Report a bug...',
    requiresPremium: false,
    mail: {
      subjectKey: 'mailItems.bugReport.subject',
      bodyKey: 'mailItems.bugReport.body',
    },
  },
]

export const addonModules = {
  innovation: ['innovation'],
  'supplier-tools': ['supplier-tools'],
  'custom-reminders': ['custom-reminders'],
  manager: ['manager'],
}

export const profileModules = {
  // FREE modules
  personal: ['house', 'flat', 'car', 'health'],
  business: ['innovator', 'manager', 'hr', 'project'],
}

export const getPicture = (grp_ID) => {
  const numericId = Number(grp_ID)
  const match = AOI_FULL_CONFIG.find(({ grp_ID: aoiId }) => aoiId === numericId)
  return match?.image ?? AOI_FULL_CONFIG[0]?.image ?? null
}

export const getEnabledAoiMap = () => {
  const initial = AOI_FULL_CONFIG.reduce((acc, { key }) => {
    acc[key] = false
    return acc
  }, {})

  if (typeof window === 'undefined') {
    return initial
  }

  return AOI_FULL_CONFIG.reduce((acc, { key }) => {
    acc[key] = window.localStorage?.getItem(key) === 'ENABLED'
    return acc
  }, initial)
}

export const createInitialModuleFlags = () =>
  AOI_FULL_CONFIG.reduce((acc, { key }) => {
    if (key) {
      acc[key] = false
    }
    return acc
  }, {})

const MODULE_TARGET_WEIGHTS = AOI_FULL_CONFIG.reduce((acc, { key, targetWeight }) => {
  if (key && typeof targetWeight === 'number') {
    acc[key] = targetWeight
  }
  return acc
}, {})

const MODULE_KEYS = Object.keys(MODULE_TARGET_WEIGHTS)

export const calculateMonthlyTarget = (moduleFlags = {}) => {
  return Object.entries(MODULE_TARGET_WEIGHTS).reduce((total, [key, weight]) => {
    return total + (moduleFlags[key] ? weight : 0)
  }, 0)
}

export const resolveModuleFlags = (flags = {}) => {
  return MODULE_KEYS.reduce((acc, key) => {
    acc[key] = Boolean(flags[key])
    return acc
  }, {})
}

export const readModuleFlagsFromStorage = () => {
  if (typeof window === 'undefined') {
    return MODULE_KEYS.reduce((acc, key) => {
      acc[key] = false
      return acc
    }, {})
  }

  const readFlag = (key) => window.localStorage.getItem(key) === 'ENABLED'

  return MODULE_KEYS.reduce((acc, key) => {
    acc[key] = readFlag(key)
    return acc
  }, {})
}

const USER_LEVEL_DEFINITIONS = [
  {
    upperBound: 1,
    level: '0',
    value: 1,
    translationKey: 'userLevels.level0',
  },
  {
    upperBound: 7,
    level: '1',
    value: 7,
    translationKey: 'userLevels.level1',
  },
  {
    upperBound: 14,
    level: '2',
    value: 14,
    translationKey: 'userLevels.level2',
  },
  {
    upperBound: 25,
    level: '3',
    value: 25,
    translationKey: 'userLevels.level3',
  },
  {
    upperBound: 40,
    level: '4',
    value: 40,
    translationKey: 'userLevels.level4',
  },
  {
    upperBound: 60,
    level: '5',
    value: 60,
    translationKey: 'userLevels.level5',
  },
  {
    upperBound: 85,
    level: '6',
    value: 85,
    translationKey: 'userLevels.level6',
  },
  {
    upperBound: 115,
    level: '7',
    value: 115,
    translationKey: 'userLevels.level7',
  },
  {
    upperBound: 150,
    level: '8',
    value: 150,
    translationKey: 'userLevels.level8',
  },
  {
    upperBound: 200,
    level: '9',
    value: 200,
    translationKey: 'userLevels.level9',
  },
  {
    upperBound: Number.POSITIVE_INFINITY,
    level: '∞',
    value: (score) => score,
    translationKey: 'userLevels.levelDefault',
  },
]

const translateLevelField = (translationKey, field) => {
  if (!translationKey) {
    return ''
  }

  const key = `${translationKey}.${field}`
  const translated = i18n.t(key, { defaultValue: '' })
  return typeof translated === 'string' ? translated : ''
}

export const getUserLevelName = (completedReminders) => {
  const numericScore = Number(completedReminders)
  const safeScore = Number.isFinite(numericScore) ? numericScore : 0

  const levelConfig =
    USER_LEVEL_DEFINITIONS.find(({ upperBound }) => safeScore < upperBound) ||
    USER_LEVEL_DEFINITIONS[USER_LEVEL_DEFINITIONS.length - 1]

  const description = translateLevelField(levelConfig.translationKey, 'description')
  const next = translateLevelField(levelConfig.translationKey, 'next')
  const task = translateLevelField(levelConfig.translationKey, 'task')
  const value =
    typeof levelConfig.value === 'function' ? levelConfig.value(safeScore) : levelConfig.value

  return {
    level: levelConfig.level,
    description,
    next,
    task,
    value,
  }
}

export const getGrpApi = (grp_ID, params) => {
  const numericId = Number(grp_ID)
  const match = AOI_FULL_CONFIG.find(
    ({ grp_ID: aoiId, scoreEndpoint }) => aoiId === numericId && scoreEndpoint,
  )
  const endpoint = match?.scoreEndpoint ?? AOI_FULL_CONFIG[0]?.scoreEndpoint ?? ''
  return endpoint ? buildApiUrl(endpoint, params) : ''
}

export const getGrpLocal = (grp_ID) => {
  const numericId = Number(grp_ID)
  const match = AOI_FULL_CONFIG.find(({ grp_ID: aoiId, key }) => aoiId === numericId && key)
  if (!match?.key) {
    return AOI_FULL_CONFIG[0]?.key ? `accountscore${AOI_FULL_CONFIG[0].key}` : ''
  }
  return `accountscore${match.key}`
}

const STATIC_KEYS_TO_REMOVE = [
  'loginName1',
  'wizard',
  'account_ID',
  'grp_ID',
  'gender',
  'mail',
  'birthday',
  'membership',
  'weather_trigger',
  'behavioral_trigger',
  'season_trigger',
  'age_trigger',
  'gender_trigger',
  'obsolescence_trigger',
  'future_trigger',
  'devicein_trigger',
  'learning_trigger',
  'patterns_trigger',
  'sensors_trigger',
  'taskid',
  'AImonth',
  'profileType',
  'score1',
  'score2',
  'score3',
  'score4',
  'score5',
  'score6',
  'score7',
  'score8',
  'score9',
  'score10',
  'score11',
  'score12',
  'newmembership',
  'newprice',
  'message_id',
  'supplierid',
  'suppliertel',
  'timerhours',
  'timerminutes',
  'error',
  'transfercontact1',
  'accountscore',
]

const AOI_KEYS_TO_REMOVE = AOI_FULL_CONFIG.reduce((acc, { key }) => {
  if (!key) {
    return acc
  }
  acc.push(key, `${key}Age`, `accountscore${key}`)
  return acc
}, [])

export const keysToRemove = Array.from(new Set([...STATIC_KEYS_TO_REMOVE, ...AOI_KEYS_TO_REMOVE]))

export const TRIGGER_KEYS = [
  'weather_trigger',
  'behavioral_trigger',
  'season_trigger',
  'age_trigger',
  'gender_trigger',
  'obsolescence_trigger',
  'future_trigger',
  'devicein_trigger',
  'learning_trigger',
  'patterns_trigger',
  'sensors_trigger',
]
